import {observer} from "mobx-react";
import * as React from "react";
import {observable} from "mobx";
import {UserAnswer} from "components/quiz/UserAnswer";
import {QuizQuestion} from "components/quiz/QuizQuestion";
import {Range} from "react-range";

interface IRangeSelectorValueProps {
  userAnswer:UserAnswer;
}

@observer
export class RangeSelectorValue extends React.Component<IRangeSelectorValueProps> {
  @observable options: Array<string> = ['Not properly configured', 'Not properly configured']
  @observable minLabel: string = '';
  @observable maxLabel: string = '';
  @observable value: number = 0;
  @observable showNextButton: boolean = false;

  initialize = (props: IRangeSelectorValueProps) => {
    if (props.userAnswer.step.rangeSteps) {
      let options = props.userAnswer.step.rangeSteps.split(',');

      if (options.length > 0) {
        for (let i = 0; i < options.length; i++) {
          options[i] = options[i].trim();
        }
        const minLabel = options[0];
        const maxLabel = options[options.length - 1];
        const initialStepValue = props.userAnswer.step.initialStepValue ? props.userAnswer.step.initialStepValue : minLabel;
        let idx = options.indexOf(initialStepValue);
        if (-1 == idx) {
          idx = 0;
        }

        if(props.userAnswer.answerValue && props.userAnswer.answerValue>0 && props.userAnswer.answerValue<=options.length) {
          idx = props.userAnswer.answerValue;
        }

        this.options = options;
        this.minLabel = minLabel;
        this.maxLabel = maxLabel;
        this.value = idx;
      }
    }
  }

  componentWillMount() {
    this.initialize(this.props);
  }

  componentWillReceiveProps(props) {
    this.initialize(props);
  }

  handleChange = (value) => {
    this.value = value;
  }

  handleChangeComplete() {
    // not used
  }

  render() {

    const readout = this.options[this.value];
    return (
      <QuizQuestion>
        <div className="slider value">
          <Range
            min={0}
            max={this.options.length - 1}
            step={1}
            values={[ this.value ]}
            onChange={(v)=>{ this.handleChange(v[0]); }}
            onFinalChange={(v)=>{  this.handleChange(v[0]); this.handleChangeComplete(); }}
            renderTrack={({ props, children }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: '6px',
                  width: '100%',
                  backgroundColor: 'rgb(235 235 235)',
                  borderRadius:'3px',
                }}
              >
                {children}
              </div>
            )}
            renderThumb={({ props }) => (
              <div
                {...props}
                style={{
                  ...props.style,
                  height: '30px',
                  width: '30px',
                  backgroundColor: '#FFF',
                  boxShadow:'0 1px 3px rgb(0 0 0 / 40%), 0 -1px 3px rgb(0 0 0 / 40%)',
                  borderRadius:'15px',
                }}
              />
            )}
          />


          <div className="labels">
            <div className="min">↑ {this.minLabel}</div>
            <div className="max">{this.maxLabel} ↑</div>
          </div>
          <div className="readout">
            {readout}
          </div>
        </div>
      </QuizQuestion>
    );
  }
}
